import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-download-progress',
    templateUrl: './download-progress.component.html',
    styleUrls: ['./download-progress.component.scss'],
    standalone: false
})
export class DownloadProgressComponent implements OnInit {
  progress: number = 0;
  totalSize: string = '';
  downloadedSize: string = '';
  fileName: string = '';
  remainingTime: string = '';

  private progressInterval: any;
  private timeInterval: any;
  private estimatedTotalSeconds: number = 45; // Assume 45s for simulation
  public isFast: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<DownloadProgressComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.fileName = data.fileName || 'document.pdf';
      if (data.isFast) {
        this.isFast = true;
        this.estimatedTotalSeconds = 2; // Fast mode estimated time
      }
    }
  }

  ngOnInit(): void {
    this.startSimulatedProgress();
  }

  startSimulatedProgress(): void {
    this.progress = 0;
    this.remainingTime = `${this.estimatedTotalSeconds} ${this.translateService.instant('SIGNUP.seconds')}`;
    
    let secondsElapsed = 0;
    
    // Progress increment interval
    this.progressInterval = setInterval(() => {
      if (this.progress < 90) {
        if (this.isFast) {
           // Fast mode: increment very quickly
           const increment = Math.random() * 5 + 10; // 10% to 15%
           this.progress = parseFloat((this.progress + increment).toFixed(1));
        } else {
           // Increment much slower: ~0.2% to 0.8% every 800ms
           const increment = Math.random() * 0.6 + 0.2;
           this.progress = parseFloat((this.progress + increment).toFixed(1));
        }
        if (this.progress > 90) this.progress = 90;
      }
    }, this.isFast ? 100 : 800);


    // Remaining time countdown interval
    this.timeInterval = setInterval(() => {
      secondsElapsed++;
      const remaining = this.estimatedTotalSeconds - secondsElapsed;
      if (remaining > 5) {
        this.remainingTime = `${remaining} ${this.translateService.instant('SIGNUP.seconds')}`;
      } else if (remaining > 0) {
        this.remainingTime = `a few seconds`;
      } else {
        this.remainingTime = `almost ready`;
      }
    }, 1000);
  }

  completeProgress(onComplete: () => void): void {
    if (this.progressInterval) clearInterval(this.progressInterval);
    if (this.timeInterval) clearInterval(this.timeInterval);
    
    this.progress = 100;
    // this.remainingTime = 'Complete';
    if (!this.isFast) {
       this.downloadedSize = this.totalSize;
    }
    onComplete();
    // Wait for 2 seconds then execute callback
    // setTimeout(() => {
    //   onComplete();
    // }, 2000);
  }

  cancelDownload(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    this.dialogRef.close('cancel');
  }

  updateProgress(loaded: number, total: number | undefined): void {
    // If we receive real progress events, we can use them
    // but the user wants it to look "smooth" even if events are sparse
    if (total) {
      const realProgress = Math.round((loaded / total) * 100);
      if (realProgress > this.progress) {
        this.progress = realProgress;
      }
      if (!this.isFast) {
         this.totalSize = this.formatBytes(total);
         this.downloadedSize = this.formatBytes(loaded);
      }
    } else {
      if (!this.isFast) {
         this.downloadedSize = this.formatBytes(loaded);
      }
    }
  }

  private formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
